let dash = null;

export async function dashjs() {
  if (dash == null) {
    // Vite/Rollup handles dynamic imports without webpack magic comments
    dash = await import('dashjs/dist/dash.mediaplayer.debug');
  }

  return dash;
}
